import SAPIcon from "../assets/images/icons/simple-icons_sap.svg";
import PrimaryIcon from "../assets/images/icons/ph_database.svg";
import PMIcon from "../assets/images/icons/pm.svg";
import PajamasIcon from "../assets/images/icons/pajamas_admin.svg";
import ClipboardIcon from "../assets/images/icons/u_clipboard-notes.svg";
import ReportIcon from "../assets/images/icons/lucide_edit-3.svg";
import AdminIcon from "../assets/images/icons/eos-icons_admin-outlined.svg";
import BoxIcon from "../assets/images/icons/u_box.svg";
import SettingIcon from "../assets/images/icons/u_setting.svg";
import ServiceIcon from "../assets/images/icons/mdi_account-service-outline.svg";

const MAIN_MENU = [
  {
    name: "SAP_Master",
    label: "ข้อมูลหลัก (SAP)",
    img: { src: SAPIcon, alt: "SAP Master Icon" },
    submenu: [
      { name: "company", label: "ข้อมูลบริษัท", path: "/sap_master/company" },
      { name: "customer", label: "ข้อมูลลูกค้า", path: "/sap_master/customer" },
      {
        name: "CheckBranchStatus",
        label: "ตรวจสอบสถานะสาขา",
        path: "/sap_master/branch"
      },
      { name: "product", label: "ข้อมูลสินค้า", path: "/sap_master/product" },
      { name: "employee", label: "ข้อมูลพนักงาน", path: "/sap_master/employee" }
    ]
  },
  {
    name: "WO_Master",
    label: "ข้อมูลหลัก (WO)",
    img: { src: PrimaryIcon, alt: "Primary Icon" },
    submenu: [
      {
        name: "ServiceType",
        label: "ข้อมูลประเภทบริการ",
        path: "/wo_master/service_type"
      },
      {
        name: "McType",
        label: "กำหนด MC Type",
        path: "/wo_master/machine_type"
      },
      {
        name: "JobType",
        label: "ข้อมูลประเภทงาน",
        path: "/wo_master/job_type"
      },
      {
        name: "DocPrefix",
        label: "กำหนดอักษรนำหน้าเลขที่เอกสาร",
        path: "/wo_master/assign_prefix"
      },
      {
        name: "SequenceStatus",
        label: "ข้อมูลสถานะใบสั่งงาน",
        path: "/wo_master/work_order_status"
      },
      { name: "Reason", label: "ข้อมูลเหตุผล", path: "/wo_master/reason" },
      { name: "FOC", label: "ข้อมูล FOC", path: "/wo_master/FOC" },
      { name: "BOM", label: "BOM", path: "/wo_master/BOM" },
      {
        name: "OperatingProcedures",
        label: "ขั้นตอนการปฏิบัติงาน",
        path: "/wo_master/operating"
      },
      {
        name: "ServiceRequest",
        label: "คำสั่งหน้าใบสั่งงาน (Service request)",
        path: "/wo_master/request"
      },
      {
        name: "Warranty",
        label: "กำหนด Warranty",
        path: "/wo_master/warranty_period"
      },
      {
        name: "TechnicianTeam",
        label: "ข้อมูลทีมช่าง",
        path: "/wo_master/technican_team"
      }
    ]
  },
  {
    name: "ArchiveView",
    label: "ข้อมูลคลัง-View",
    img: { src: BoxIcon, alt: "Archive Icon" },
    submenu: [
      { name: "Archive", label: "ข้อมูลคลัง", path: "/archive_view/archive" },
      {
        name: "property",
        label: "ข้อมูลทรัพย์สิน",
        path: "/archive_view/property"
      },
      {
        name: "StatusBalance",
        label: "สถานะและยอดคงเหลือ",
        path: "/archive_view/status_balance"
      },
      {
        name: "Pickedup",
        label: "เบิกสินค้าสำเร็จ",
        path: "/archive_view/pickedup"
      },
      {
        name: "Returned",
        label: "คืนสินค้าสำเร็จ",
        path: "/archive_view/returned"
      }
    ]
  },
  {
    name: "GeneralJobNotify",
    label: "การแจ้งงานทั่วไป",
    img: { src: ClipboardIcon, alt: "Service Icon" },
    submenu: [
      {
        name: "CreateJob",
        label: "สร้างใบแจ้งงาน",
        path: "/general_job/create"
      },
      {
        name: "FollowStatusService",
        label: "ติดตามสถานะงานบริการ",
        path: "/general_job/follow"
      }
    ]
  },
  {
    name: "InstallationWork",
    label: "งานติดตั้ง",
    img: { src: SettingIcon, alt: "Service Icon" },
    submenu: [
      {
        name: "RecordDetails",
        label: "สร้างใบแจ้งงานติดตั้ง",
        path: "/installation_work/record"
      },
      {
        name: "CheckReceive",
        label: "ตรวจสอบและรับรายการแจ้ง",
        path: "/installation_work/check"
      },

      {
        name: "IssueInstallation",
        label: "ออกใบสั่งงานติดตั้ง",
        path: "/installation_work/issue"
      },
      {
        name: "ReturnInstallation",
        label: "คืนทรัพย์สิน",
        path: "/installation_work/return"
      }
    ]
  },
  {
    name: "PMWork",
    label: "งาน PM",
    img: { src: PMIcon, alt: "PM work Icon" },
    submenu: [
      { name: "MAService", label: "สัญญางานบริการ MA", path: "/MA_service" },
      { name: "BindPM", label: "ผูกสัญญางานบริการ PM", path: "/PM_work/bind" },
      {
        name: "CreatePM",
        label: "สร้างสัญญางานบริการ PM",
        path: "/PM_work/create"
      },
      { name: "PMPlan", label: "แผน PM", path: "/PM_work/plan" },
      { name: "AdjustPlan", label: "ปรับแผน", path: "/PM_work/adjust" },
      {
        name: "FollowService",
        label: "ติดตามสถานะงานบริการ",
        path: "/PM_work/follow"
      }
    ]
  },
  {
    name: "RepairWork",
    label: "งานแจ้งซ่อม",
    img: { src: PajamasIcon, alt: "Pajamas Icon" },
    submenu: [
      {
        name: "CheckCustomerHistory",
        label: "ตรวจสอบประวัติลูกค้า",
        path: "/repair_work/history"
      },
      {
        name: "RecordRepairNotification",
        label: "สร้างใบแจ้งซ่อม",
        path: "/repair_work/record"
      },
      {
        name: "IssueWorkOrderRepairs",
        label: "ออกใบสั่งงานแจ้งซ่อม",
        path: "/repair_work/issue"
      },
      {
        name: "FollowStatusRepairs",
        label: "ติดตามสถานะงานแจ้งซ่อม",
        path: "/repair_work/follow"
      }
    ]
  },
  {
    name: "ServiceWork",
    label: "งานบริการ (ช่าง)",
    img: { src: ServiceIcon, alt: "Service Icon" },
    submenu: [
      {
        name: "HeadEventPlanning",
        label: "หัวหน้าวางแผนงาน",
        path: "/service_work/planning"
      },
      {
        name: "JobAcceptanceTeam",
        label: "ทีมงานรับงาน",
        path: "/service_work/acceptance"
      },
      {
        name: "PerformServiceRequest",
        label: "ปฏิบัติงานตาม Service Request",
        path: "/service_work/perform"
      },
      {
        name: "ReturnEquipment",
        label: "คืนอุปกรณ์/อะไหล่",
        path: "/service_work/return_equipment"
      },
      {
        name: "ExpensesDuringWork",
        label: "ค่าใช้จ่ายระหว่างทำงาน",
        path: "/service_work/expenses"
      },
      {
        name: "DeliveryDocuments",
        label: "นำส่งเอกสาร",
        path: "/service_work/delivery"
      }
    ]
  },
  {
    name: "RequestReimbursementRefund",
    label: "ใบขอเบิก/ขอคืน",
    img: { src: ClipboardIcon, alt: "Clipboard Icon" },
    path: "/reimbursement_refund"
  },
  {
    name: "Report",
    label: "รายงาน",
    img: { src: ReportIcon, alt: "Report Icon" },
    path: "/report"
  },
  {
    name: "Administrator",
    label: "ผู้ดูแลระบบ",
    img: { src: AdminIcon, alt: "Admin Icon" },
    path: "/administrator"
  }
];

export { MAIN_MENU };
